
import { client } from '@/common-utils/libraries/axios/axios';
import { SIM_CARDS } from '../apiUrls';

const mutationMultiActivateSimCards = (onSuccess, onError) => {
    return {
        mutationFn: ({ simCardPlan, simCardIds }) => {
            return client.post(SIM_CARDS.ACTIVATE.url, { offer: simCardPlan, uuids: simCardIds });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: (data) => {
            onSuccess(data);
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationMultiActivateSimCards;